import styled, { css } from 'styled-components';
import { getTextType, getSpace } from '../../../stylesheets/tools';

const StyledHeadline = styled.h2`
  text-transform: uppercase;
  hyphens: auto;
  word-wrap: break-word;
  font-weight: 400;
  margin: 0;

  /* Props based on variables */
  ${props =>
    props.disableHyphens &&
    css`
      hyphens: none;
    `};

  ${props =>
    props.big &&
    css`
      ${getTextType('big')};
    `};

  ${props =>
    props.primary &&
    css`
      ${getTextType('primary')};
    `};

  ${props =>
    props.secondary &&
    css`
      ${getTextType('secondary')};
    `};

  ${props =>
    props.tertiary &&
    css`
      ${getTextType('tertiary')};
    `};

  ${props =>
    props.subline &&
    css`
      ${getTextType('subline')};
      margin-bottom: ${getSpace('xxs')};
      display: inline-block;
    `};

  ${props =>
    props.main &&
    css`
      ${getTextType('main')};
    `};

  ${props =>
    props.teaser &&
    css`
      ${getTextType('teaser')};
    `};

  ${props =>
    props.listTeaser &&
    css`
      ${getTextType('listTeaser')};
    `};
`;

export default StyledHeadline;
